import { CreateStaffTicketCommentRequest, TicketStatus } from "@signalist/shared-types";

export type ComposerMode = "PUBLIC" | "INTERNAL";

/** "Then set" offers every staff status (decision 8), in the pill order of the queue. */
export const THEN_SET_STATUSES: readonly TicketStatus[] = [
	TicketStatus.OPEN,
	TicketStatus.WAITING_ON_US,
	TicketStatus.WAITING_ON_CUSTOMER,
	TicketStatus.RESOLVED,
	TicketStatus.CLOSED,
];

/**
 * What the API does with a public reply anyway (`ticket-transitions.ts`, STAFF_PUBLIC_COMMENT):
 * OPEN / WAITING_ON_US hand the ticket to the customer, the other three keep their status — a
 * reply on a resolved ticket is a courtesy, not a reopen. The composer preselects this so "Then
 * set" reads as a confirmation, and always sends the selection (one STATUS_CHANGE row either way).
 */
export const defaultThenSetStatus = (current: TicketStatus): TicketStatus =>
	current === TicketStatus.OPEN || current === TicketStatus.WAITING_ON_US
		? TicketStatus.WAITING_ON_CUSTOMER
		: current;

export interface ComposerLabels {
	placeholder: string;
	hint: string;
	send: string;
	showThenSet: boolean;
}

/** The leaf keys under `support.staff.detail.composer` each mode renders. */
export const composerLabels = (mode: ComposerMode): ComposerLabels =>
	mode === "INTERNAL"
		? {
				placeholder: "placeholderInternal",
				hint: "hintInternal",
				send: "addNote",
				showThenSet: false,
			}
		: {
				placeholder: "placeholderPublic",
				hint: "hintPublic",
				send: "sendReply",
				showThenSet: true,
			};

/** The body of `POST tickets/admin/:id/comments` for the mode: a note never carries a status. */
export const buildStaffCommentRequest = (
	mode: ComposerMode,
	message: string,
	thenSet: TicketStatus
): CreateStaffTicketCommentRequest =>
	mode === "INTERNAL" ? { message, isInternal: true } : { message, status: thenSet };
